import React, { memo, useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { Config } from "../../../Utils/Config";
import { Row, Col } from "reactstrap";
import "mapbox-gl/dist/mapbox-gl.css";
import WebMercatorViewport from "viewport-mercator-project";
import logo from "../../../Assets/Images/logo.png";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { PdfMap } from "../Index";
import { commonFormatNumber, formatSeasonalityText, getImageSrc } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";


const applyToArray = (func, array) => func.apply(Math, array);
let summary;
var supplyExtp = [];
var supplyCircles = {};
var demandExtp = [];
var demandCircles = {};

const DownloadReport = memo((props) => {
  let date = new Date();
  const [marketSummary, setMarketSummary] = useState({});
  const { id, key } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [supplyRadius, setSupplyRadius] = useState(0);
  const [demandRadius, setDemandRadius] = useState(0);
  const [marketInfo, setMarketInfo] = useState({});
  const mapRef = useRef();
  const [viewport, setViewPort] = useState({
    width: "100%",
    height: "100vh",
    longitude: -97.86589,
    latitude: 37.70959,
    zoom: 3.5,
    cursor: "pointer",
  });
  const [address, setAddress] = useState("");
  const [marketPois, setMarketPois] = useState({});
  const [showUserLogo, setShowUserLogo] = useState(null)
  const displayLogo = showUserLogo ? showUserLogo : logo;
  const [companyInfo, setCompanyInfo] = useState({
    companyName: 'RVParkIQ',
    companyURL: "https://rvparkiq.com",
  })

  useEffect(() => {
    getReportDetails();
    getUserLogo();
  }, []);

  const getUserLogo = () => {
    let sKey = !key ? null : key;
    apiCommonTrigger("get" , Config.API_URL + "/markets/userlogo/" , [sKey])
    .then((res) => {
      if (res.status === 200) {
        const logo = getImageSrc(res.data.userlogoblob);
        setShowUserLogo(logo);
      } else {
        handlingCatchError(res, navigate);
      }
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  //draw circle
  const getDemandCircle = (dLat, dLong, radius) => {
    demandCircles = {};
    let radiusCal = radius;
    let lat = dLat;
    let lng = dLong;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    demandExtp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      demandExtp.push([ey, ex]);
    }
    demandCircles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: demandExtp,
      },
    };
    getBoundingValues(demandCircles);
  };

  //calculate bounding box value for circle default adjustment
  const getBoundingValues = (points) => {
    if (points) {
      const pointsLong = points.geometry.coordinates.map((point) => point[0]);
      const pointsLat = points.geometry.coordinates.map((point) => point[1]);
      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)],
      ];
      const viewport = new WebMercatorViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      }).fitBounds(cornersLongLat, {
        padding: { top: 100, bottom: 100, left: 100, right: 100 },
      });
      const { longitude, latitude, zoom } = viewport;
      setViewPort({
        ...viewport,
        latitude: latitude,
        longitude: longitude,
        zoom: zoom,
      });
    }
  };

  //draw circle
  const getSupplyCircle = (sLat, sLng, radius) => {
    supplyCircles = {};
    let radiusCal = radius;
    let lat = sLat;
    let lng = sLng;
    let dir = 1;
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 64;
    // find the raidus in lat/lon
    var rlat = (radiusCal / earthsradius) * r2d;
    var rlng = rlat / Math.cos(lat * d2r);

    supplyExtp = [];
    if (dir === 1) {
      var start = 0;
      var end = points + 1;
    } else {
      var start = points + 1;
      var end = 0;
    }
    for (var i = start; dir === 1 ? i < end : i > end; i = i + dir) {
      var theta = Math.PI * (i / (points / 2));
      let ey = lng + rlng * Math.cos(theta);
      let ex = lat + rlat * Math.sin(theta);
      supplyExtp.push([ey, ex]);
    }
    supplyCircles = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: supplyExtp,
      },
    };
    getBoundingValues(supplyCircles);
  };

  //get report info
  const getReportDetails = () => {
    // setLoading(true);
      apiCommonTrigger("post",`${Config.API_URL}/markets/market/report/summarydata`, {
           marketId: !parseInt(id) ? null : parseInt(id),
        securityKey: !key ? null : key,
          }) 
    .then((res) => {
      setLoading(false);
      if (res.status === 200) {
        let marketDetails = res.data.marketdata;
        let addressLine = marketDetails.streetaddress1
          ? marketDetails.streetaddress1
          : "";
        let fmtAddress = marketDetails.profileid
          ? addressLine + ", "
          : addressLine;
        let city = marketDetails.city ? marketDetails.city + ", " : "";
        let state = marketDetails.statecode ? marketDetails.statecode : "";
        let country = marketDetails.countryname
          ? " " + marketDetails.countryname
          : "";
        setMarketSummary({ ...marketSummary, marketSummary: res.data });
        setAddress(fmtAddress + city + state + country);
        setMarketPois(res.data.marketpois);
        setViewPort({
          ...viewport,
          lat: marketDetails.latitude,
          lng: marketDetails.longitude,
        });
        setDemandRadius(marketDetails.demandradius);
        setSupplyRadius(marketDetails.supplyradius);
        setMarketInfo(marketDetails);
        getSupplyCircle(
          marketDetails.latitude,
          marketDetails.longitude,
          marketDetails.supplyradius
        );
        getDemandCircle(
          marketDetails.latitude,
          marketDetails.longitude,
          marketDetails.demandradius
        );
      } else {
        handlingCatchError(res, navigate);
      }
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  //get parks summary details
  const getSummaryDetails = () => {
    summary = [];
    let summaryDetails = marketSummary.marketSummary.summary;

    const excludedKeys = new Set([
      "rvparkids",
      "caucasian",
      "black",
      "hispanic",
      "others",
      "avgmaleinmarket",
      "avgfemaleinmarket",
      "asianpacific",
      "totalrvparksites",
      "marketdemandformarket",
      "marketdemandfornational",
      "demandsuppyratioformarket",
      "demandsuppyratiofornational",
      "rvparkdemandscorefornational",
      "rvparkdemandscoreformarket",
      "percentageofhousehold",
      "potentialcampers",
      "avgfuelcost"
    ]);

    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {

      const key = Object.keys(summaryDetails)[i].toLowerCase(); // Convert key to lowercase
      const value = Object.values(summaryDetails)[i];
      if (value !== null && value !== undefined && value !== "" && value !== 0 && !excludedKeys.has(key)) {

        const headerMap = {
          rvparksinmarket: "RV Parks in market",
          avgpricepernight: "Average price per night",
          countofhousehold: "Households",
          avgsizeofpark: "Average Size Of Park",
          rvownershipinmarket: "RV Ownership in market",
          population: "Population",
          populationdensity: "Population Density(per sq mi)",
          regiontype: "Region Type",
          incomepercapita: "Income per capita",
          avgfuelcost: "Average Fuel Cost",
          avgage: "Average Age",
          fivetotwentyfour: "Population age from 5-24",
          twentyfivetofortyfour: "Population age from 25-44",
          fortyfivetofiftyfour: "Population age from 45-54",
          fiftyfivetoseventyfour: "Population age from 55-74",
          seventyfiveandabove: "Population age of 75 And Above",
          demandsupplyratioformarket: "Demand Supply Ratio For Market",
          demandsupplyratiofornational: "Demand Supply Ratio For National"
        };

        // Get the key and convert it to lowercase
        const key = Object.keys(summaryDetails)[i].toLowerCase();

        // Use the headerMap to get the table header or default to the key if not found
        let tableHeader = headerMap[key] || key;


        let formatValue = priceConversion(Object.values(summaryDetails)[i]);
        let headerValue =
          (Object.keys(summaryDetails)[i] === "avgfuelcost" ||
            Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita")
            && formatValue !== '-' ? Config.Currency + formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleinmarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleinmarket")
                && formatValue !== '-' ? formatValue + "%"
                : formatValue;

        summary.push(
          <TableRow key={Object.keys}>
            <TableCell>{tableHeader}</TableCell>
            <TableCell>{headerValue}</TableCell>
          </TableRow>
        );
      }
    }
    return summary;
  };

  //price conversion
  const priceConversion = (tot) => {
    return commonFormatNumber(tot);    
  };

  //change center point on lat lng  changed
  const handleViewportChange = useCallback((newViewport) =>
    setViewPort(newViewport)
  );

  const genSingleSideHeading = () => {
    return (
      <Col sm={6} className="table-col">
        <div className="table-lists">
          <p>
            <span className="only-title">Interactive Map</span>{" "}
            <span className="only-value">1</span>
          </p>
          <p>
            <span className="only-title">Market Summary</span>{" "}
            <span className="only-value">2</span>
          </p>
          <p>
            <span className="only-title">Competitors </span>{" "}
            <span className="only-value">3</span>
          </p>
        </div>
      </Col>
    );
  };

  return (
    <React.Fragment>
      <div className={!showUserLogo ? "print-pdf detail-pdf summary_report_pdf with_our_logo" : "print-pdf summary_report_pdf detail-pdf with_client_logo"}>
        <section className="pdf-wid-wrapper cover-page">
          <div className="cover-header">
            <img src={displayLogo} alt="RVParkIQ" className="client-logo" />
            <h1><span>Summary</span><br />Report</h1>
            <p>Produced on {moment(date).format("MMM DD YYYY")}</p>
          </div>

          <div className="cover-report-for">
            <h5>Report for: </h5>{" "}
            <React.Fragment>
              {/* <p className="market-title">{marketInfo && marketInfo.marketName ? marketInfo.marketName : ''}</p> */}
              <p
                dangerouslySetInnerHTML={{
                  __html: marketInfo.supplyradius
                    ? marketInfo.supplyradius + " miles around " + address
                    : "",
                }}
                className="market-title"
              />{" "}
            </React.Fragment>
          </div>
          <div className="cover-footer">
            <div className="contact-address">
              <h4>{companyInfo?.companyURL}</h4>
            </div>
          </div>
          <div id="pbreak" className="page-break" />
        </section>
        <div id="pbreak" className="page-break" />
        {/* table of contents */}
        <section className="pdf-wid-wrapper">
          <header className="page-header">
            <div className="page-logo">
              <a href="#">
                <img src={displayLogo} alt="RVParkIQ" />
              </a>
            </div>
            <div className="header-address">
              <p>{address}</p>
            </div>
            <div className="clear"></div>
          </header>
          <div className="page-body">
            <Row className="m-0">
              <div className="table-content-only">
                <Col md={12} className="text-center">
                  <h3>
                    Table of Contents <span></span>
                  </h3>
                </Col>
                {genSingleSideHeading()}
              </div>
            </Row>
          </div>
          <footer className="page-footer">
            <div>
              This report is powered by data insights from {companyInfo?.companyName}. Visit <a href={companyInfo?.companyURL} target="_blank">{companyInfo?.companyURL}</a> © {(new Date().getFullYear())} {companyInfo?.companyName}.
            </div>
          </footer>
          <div id="pbreak" className="page-break" />
        </section>
        {/* map section */}
        {marketInfo && marketInfo.latitude && marketInfo.longitude ? (
          <section className="pdf-wid-wrapper">
            <header className="page-header">
              <div className="page-logo">
                <a href="#">
                  <img src={displayLogo} alt="RVParkIQ" />
                </a>
              </div>
              <div className="header-address">
                <p>{address}</p>
              </div>
              <div className="clear"></div>
            </header>
            <div className="page-number">Page No: 1</div>
            <div className="page-body">
              <h4 className="pdf-title">Map</h4>

              <PdfMap
                data={marketInfo}
                marketPois={marketPois}
                address={address}
              />
            </div>
            <div id="pbreak" className="page-break" />
          </section>
        ) : (
          ""
        )}
        {/* summay */}
        <section className="pdf-wid-wrapper">
          <header className="page-header">
            <div className="page-logo">
              <a href="#">
                <img src={displayLogo} alt="RVParkIQ" />
              </a>
            </div>
            <div className="header-address">
              <p>{address}</p>
            </div>
            <div className="clear"></div>
          </header>
          <div className="page-number">Page No: 2</div>
          <div className="page-body">
            <h4 className="pdf-title">Market Summary</h4>

            <div>
              <Table className="table-design market-summary-pdf two-col-table">
                <TableBody>
                  {marketSummary &&
                    marketSummary.marketSummary &&
                    marketSummary.marketSummary.summary &&
                    getSummaryDetails()}
                  {marketSummary &&
                    marketSummary.marketSummary &&
                    marketSummary.marketSummary.summary &&
                    marketSummary.marketSummary.summary.length === 0 ? (
                    <TableRow>
                      <TableCell
                        style={{ textAlign: "center" }}
                        className="store-no-data"
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  ) : (
                    null
                  )}
                </TableBody>
              </Table>
              <Row className="two-col-print no-heading-col">
                <Col md="6">
                  <Table className="table-design market-summary-pdf">
                    <TableBody>
                      <TableRow>
                        <TableCell>Facility Name</TableCell>
                        <TableCell>
                          {marketInfo && marketInfo.profilename
                            ? marketInfo.profilename
                            : "-"}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>{address && address}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Land Size</TableCell>
                        <TableCell>
                          {marketInfo && marketInfo.landsize
                            ? priceConversion(marketInfo.landsize) + " Acres"
                            : "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>No of Spots</TableCell>
                        <TableCell>
                          {marketInfo && marketInfo.noofsites
                            ? marketInfo.noofsites
                            : "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Seasonality</TableCell>
                        <TableCell>
                          {marketInfo && marketInfo.seasonalityname
                            ? marketInfo.seasonalityname
                            : "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Year Opened</TableCell>
                        <TableCell>
                          {marketInfo && marketInfo.yearopened
                            ? marketInfo.yearopened
                            : "-"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Col>
                <Col md="6">
                  <Table className="table-design market-summary-pdf">
                    <TableBody>
                      <TableRow>
                        <TableCell>Demand Supply Ratio<br />
                          <span>(Number of Campers per Camping Spots.)</span>
                        </TableCell>
                        <TableCell>
                          {marketSummary &&
                            marketSummary.marketSummary &&
                            marketSummary.marketSummary.summary &&
                            marketSummary.marketSummary.summary
                              .demandsupplyratioformarket !== null
                            ? marketSummary.marketSummary.summary
                              .demandsupplyratioformarket
                            : "-"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Total Camping Spots</TableCell>
                        <TableCell>
                          {marketSummary &&
                            marketSummary.marketSummary &&
                            marketSummary.marketSummary.summary &&
                            marketSummary.marketSummary.summary
                              .totalrvparksites !== null
                            ? marketSummary.marketSummary.summary
                              .totalrvparksites
                            : "-"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Col>
              </Row>
            </div>
          </div>

          <div id="pbreak" className="page-break" />
        </section>
        {/* competitor */}
        <section className="pdf-wid-wrapper">
          <header className="page-header">
            <div className="page-logo">
              <a href="#">
                <img src={displayLogo} alt="RVParkIQ" />
              </a>
            </div>
            <div className="header-address">
              <p>{address}</p>
            </div>
            <div className="clear"></div>
          </header>
          <div className="page-number">Page No: 3</div>
          <div className="page-body">
            <h4 className="pdf-title">Competitors</h4>
            {marketSummary &&
              marketSummary.marketSummary &&
              marketSummary.marketSummary.competitors &&
              marketSummary.marketSummary.competitors.length > 0 ? (
              <p className="desc-para">
                Three closest competitors to the market center
              </p>
            ) : (
              ""
            )}
            <Col md="12" className="competitor-pdf">
              <Table className="table-design market-summary-pdf">
                {marketSummary &&
                  marketSummary.marketSummary &&
                  marketSummary.marketSummary.competitors &&
                  marketSummary.marketSummary.competitors.length > 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell></TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return <TableCell>Competitor {index + 1}</TableCell>;
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>Competitor</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return <TableCell>{data.profilename}</TableCell>;
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>Drive Distance</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return (
                            <TableCell>
                              {data.drivedistance
                                ? priceConversion(data.drivedistance) === "0.00"
                                  ? "0 miles"
                                  : priceConversion(data.drivedistance) +
                                  " miles"
                                : "-"}
                            </TableCell>
                          );
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>Address</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return (
                            <TableCell>
                              {data.streetaddress1
                                ? data.streetaddress1 + ", "
                                : ""}
                              {data.city ? data.city : ""}
                              {data.statecode ? " " + data.statecode : ""}
                            </TableCell>
                          );
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>Land Size</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return (
                            <TableCell>
                              {data.landsize ? priceConversion(data.landsize) + "Acres" : "-"}
                            </TableCell>
                          );
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>No Of Spots</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return (
                            <TableCell>
                              {data.noofsites ? priceConversion(data.noofsites) : "-"}
                            </TableCell>
                          );
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>Seasonal Name</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return (
                            <TableCell>
                              {data.seasonalname ? formatSeasonalityText(data.seasonalname) : "-"}
                            </TableCell>
                          );
                        }
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell>Year Opened</TableCell>
                      {marketSummary.marketSummary.competitors.map(
                        (data, index) => {
                          return (
                            <TableCell>
                              {data.yearopened ? data.yearopened : "-"}
                            </TableCell>
                          );
                        }
                      )}
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{ textAlign: "center" }}
                        className="store-no-data"
                      >
                        No competitors Available
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </Col>
          </div>

          <div id="pbreak" className="page-break" />
        </section>
      </div>
    </React.Fragment>
  );
});

export default DownloadReport;
